const action = (value) => value === 'confirm-vacant' || value === 'preserve-historical' ||
    value === 'create-inactive-member' || value === 'create-active-member' ||
    value === 'release-undocumented-holder' || value === 'assign-existing-member';
export function isMemberImportReconciliationResponse(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const item = value;
    return typeof item.batchId === 'string' &&
        ['total', 'matched', 'pending', 'resolved'].every((key) => Number.isInteger(item[key])) &&
        Array.isArray(item.rows) && item.rows.every((row) => typeof row.id === 'string' && Number.isInteger(row.rowNumber) &&
        (row.status === 'pending' || row.status === 'resolved') && Array.isArray(row.issues));
}
export function isMemberImportResolutionResponse(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const item = value;
    return typeof item.rowId === 'string' && item.status === 'resolved' && action(item.action) &&
        typeof item.resolvedAt === 'string' && typeof item.duplicateBlocked === 'boolean' &&
        (typeof item.memberId === 'string' || item.memberId === null);
}
